<template>
    <div class="lesson-task-handup">
        <div class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: `/lesson/${$route.params.lessonUid}/type/task` }">课堂作业</el-breadcrumb-item>
                <el-breadcrumb-item>上传作业</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card>
                <div class="lesson-task-handup-header">
                    <el-row>
                        <el-col :span="taskData.isGroup === 0 ? 24 : 12">
                          <h3 class="lesson-name" v-text="taskData.taskName"/>
                          <p v-html="taskData.describe" style="margin-top:20px"/>
                            <p class="lesson-info">
                                <time class="lesson-cutoffTime">截至：{{taskData.cutoffTime}}</time>
                              <span class="lesson-type" v-text="`${taskData.isGroup === 0 ? '个人' : '小组'}作业`"/>
                            </p>
                        </el-col>
                        <el-col :span="12" v-if="taskData.isGroup === 1">
                            <div class="header-r">
                                <el-button size="mini" @click="showMembers = true">查看小组成员</el-button>
                                <el-button size="mini" @click="showSubmitted = true">查看谁提交了</el-button>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="tools">
                        <template v-if="!submitStatus && openSubmit">
                            <el-upload ref="upload" class="upload-demo" multiple action="https://jsonplaceholder.typicode.com/posts/"  :http-request="httpRequest">
                                <el-button size="mini" type="primary" plain>上传文件</el-button>
                            </el-upload>
                            <el-button size="mini" type="primary" @click="openSubmit=false">确认提交</el-button>
                        </template>
                        <!-- <el-button v-else size="mini" type="primary" @click="openSubmit = true">重新提交</el-button> -->
                    </div>
                </div>
                <div class="annexs-list">
                    <div v-if="taskData.annexs && taskData.annexs.length > 0">
                        <el-row class="task" v-for="task in taskData.annexs" :key="task.uid">
                            <el-col :span="!submitStatus ? 20 : 24">
                                <div class="task-img">
                                  <img src="~@/assets/imgs/annotation0.png">
                                </div>
                                <div class="task-info">
                                  <p class="task-name" v-text="task.name"/>
                                    <p class="task-other">
                                      <span v-text="task.size"/>
                                        <el-button type="text" size="small" @click="handClick(task)">下载</el-button>
                                      <span v-text="task.typeText"/>
                                    </p>
                                </div>
                            </el-col>
                            <el-col :span="4" v-if="!submitStatus && openSubmit">
                                <div class="task-action">
                                    <el-button type="text" size="small" @click="handleDelete(task)" >删除</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="task-tips" v-else>
                        <p>即将提交的附件资料</p>
                    </div>
                </div>
                <div class="handup-title">
                    <el-collapse accordion v-model="activeNames" @change="handleChange">
                        <el-collapse-item :title="`操作日志 ( ${taskData.logs.length} )`" name="log">
                            <div class="log-box">
                                <div class="log-list">
                                    <div v-for="(item, index) in taskData.logs" :key="index">
                                        <p class="pre-icon">
                                          <span/>
                                          <span/>
                                          <span/>
                                        </p>
                                      <time v-text="item.time"/>
                                        &nbsp;&nbsp;
                                      <span v-text="item.content"/>
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </el-card>
        </div>
        <el-dialog title="已提交学生列表" :visible.sync="showSubmitted">
            <el-table :data="submittedList">
              <el-table-column property="name" label="姓名"/>
              <el-table-column property="id" label="学号"/>
              <el-table-column property="date" label="提交时间"/>
            </el-table>
        </el-dialog>
        <el-dialog title="小组成员列表" :visible.sync="showMembers">
            <el-table :data="studentList">
              <el-table-column property="name" label="姓名"/>
              <el-table-column property="id" label="学号"/>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import { detailTask, reportTask, delTaskReport } from '@/api/lab/tasks'
import { uploadFile, getFileInfoByUid } from '@/api/file'

export default {
    data () {
        return {
            taskData: {
                annexs: [],
                logs: []
            },
            activeNames: '',
            openSubmit: true,
            showSubmitted: false,
            submittedList: [],
            showMembers: false,
            studentList: []
        }
    },
    created () {
        this.init()
    },
    computed:{
        submitStatus(){
            return this.taskData.submitStatus === 2
        }
    },
    methods: {
        handClick(val){ //下载按钮
            getFileInfoByUid (val.uid).then(res=>{
                this.download(res)
            })
        },
        download(val){
            const ele = document.createElement('a');
            ele.setAttribute('href', this.$options.filters['filterUrl'](val.originalPath));
            ele.setAttribute('download',val.name);
            ele.style.display = 'none';
            document.body.appendChild(ele);
            ele.click();
            document.body.removeChild(ele);
        },
        init () {
            this.detailTask()
        },
        detailTask () {
            this.taskData = {
                annexs: [],
                logs: [],
                isGroup: null
            }
            detailTask(this.$route.params.uid).then(res => {
                this.taskData = res
            })
        },
        reportTask (ids) {
            reportTask(this.taskData.uid, ids).then(() => {
                this.$message.success('提交成功')
                this.detailTask()
            })
        },
        delTaskReport (ids) {
            delTaskReport(this.taskData.uid, ids).then(() => {
                this.$message.success('删除成功')
                this.detailTask()
            })
        },
        uploadFile (file) {
            // TODO
            uploadFile(file, 'lesson/tasks/report').then(res => {
                if (res) {
                    this.reportTask([res.uid])
                }
            })
        },
        // 点击了"上传文件"按钮
        submitUpload () {
            // 手动上传文件列表
            this.$refs.upload.submit()
        },
        // 文件上传 - 覆盖默认的上传行为，可以自定义上传的实现
        httpRequest (param) {
            let fileObj = param.file
            if((Number(fileObj.size)/1024/1024).toFixed(2)>20){
                this.$message.warning('上传文件大小不能超过20M!')
                this.$refs.upload.clearFiles()
            }else {
                this.uploadFile(fileObj)
                this.$refs.upload.clearFiles()
            }
        },
        // 点击了附件列表的"删除"按钮
        handleDelete (row) {
            this.delTaskReport([row.uid])
        },
        handleChange () { }
    }
}
</script>

<style lang="less">
.lesson-task-handup {
    .el-upload {
        width: 100%;
        &-dragger {
            width: 100%;
        }
    }
}
</style>

<style lang="less" scoped>
.lr {
    .fl {
        float: left;
    }
    .fr {
        float: right;
    }
    &::after {
        content: "";
        display: block;
        clear: both;
    }
}
.lesson-task-handup {
    min-height: 620px;
    padding-top: 20px;
    padding-bottom: 20px;
    .el-breadcrumb {
        line-height: 2em;
        margin-bottom: 12px;
    }
    &-header {
        border-bottom: 1px solid #dcdcdc;
        padding-bottom: 12px;
        .header-r,
        .tools {
            text-align: right;
        }
        .lesson-name {
            font-size: 24px;
            font-weight: normal;
        }
        .lesson-info {
            font-size: 16px;
            margin-top: 22px;
            > * + * {
                margin-left: 16px;
                margin-right: 16px;
            }
            .lesson-cutoffTime {
                color: #c70102;
            }
            .lesson-type {
                color: #00be64;
            }
        }
        .tools {
            > * + * {
                margin-left: 10px;
            }
            .upload-demo {
                display: inline-block;
            }
        }
    }
    .annexs-list {
        margin-top: 12px;
        padding: 14px 24px;
        border: 1px solid #dcdcdc;
        background-color: #f5fafe;
        .task {
            padding: 10px 0;
            &-img,
            &-info {
                display: inline-block;
                vertical-align: middle;
            }
            &-img {
                width: 60px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                img {
                    max-width: 100%;
                    max-height: 100%;
                }
            }
            &-info {
                margin-left: 12px;
                .task-other {
                    font-size: 0.8em;
                    color: gray;
                    margin: 12px -6px 0;
                    span {
                        margin-left: 6px;
                        margin-right: 6px;
                    }
                }
                .task-name {
                    font-size: 1em;
                    margin: 0;
                }
            }
            & + .task {
                border-top: 1px solid #dcdcdc;
            }
            .el-col {
                float: none;
                display: inline-block;
                vertical-align: middle;
            }
        }
        .task-tips {
            color: gray;
            text-align: center;
            padding: 40px;
        }
    }
    .handup-title {
        > h3,
        > div {
            & + div {
                margin-top: 20px;
            }
        }
    }
    .log-box {
        .log-list {
            border-left: 2px solid #dcdcdc;
            margin-left: 9px;
            padding-top: 1em;
            padding-bottom: 1em;
            > div {
                position: relative;
                padding-left: calc(16px + 45px + 8px + 12px);
                margin-left: -9px;
                .pre-icon {
                    line-height: 1.5em;
                    position: absolute;
                    left: 0;
                    top: 0;
                    > span {
                        display: inline-block;
                        vertical-align: middle;
                        &:nth-child(1),
                        &:nth-child(3) {
                            border-radius: 50%;
                        }
                        &:nth-child(1) {
                            width: 16px;
                            height: 16px;
                        }
                        &:nth-child(2) {
                            width: 45px;
                            height: 1px;
                            background-color: #b5b5b5;
                        }
                        &:nth-child(3) {
                            width: 8px;
                            height: 8px;
                        }
                    }
                }
                & + div {
                    margin-top: 1em;
                }
                &:nth-child(3n + 1) {
                    .pre-icon {
                        > span {
                            &:nth-child(1),
                            &:nth-child(3) {
                                background-color: #b6d26c;
                            }
                        }
                    }
                }
                &:nth-child(3n + 2) {
                    .pre-icon {
                        > span {
                            &:nth-child(1),
                            &:nth-child(3) {
                                background-color: #f8b95c;
                            }
                        }
                    }
                }
                &:nth-child(3n) {
                    .pre-icon {
                        > span {
                            &:nth-child(1),
                            &:nth-child(3) {
                                background-color: #ef8259;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
